<template>
  <form
    @submit.prevent="onSave">

    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{ $t('user.form.role_information') }}</h4>
            <p class="sub-header"></p>
            <div class="row">
              <div class="col-6">
                <TextField 
                  placeholder="Enter Role"
                  label="Role"
                  v-model="model.name"
                />
                <div class>
                  <div class="mb-2" v-if="user.role.type == 1">
                    <input
                      type="radio"
                      value="administration"
                      v-model="model.role"
                      @input="model.type = 1"
                    />
                    <label>
                      Super Admin
                    </label>
                  </div>
                  <div class="mb-2" v-if="user.role.type == 1">
                    <input
                      type="radio"
                      value="staff"
                      v-model="model.role"
                      @input="model.type = 1"
                    />
                    <label>
                      Administration/Staff
                    </label>
                  </div>
                  <div class="mb-2" v-if="user.role.type == 2 || user.role.type == 1">
                    <input
                      type="radio"
                      value="recruitment"
                      v-model="model.role"
                      @input="model.type = 2"
                    />
                    <label>
                      Recruitment/Company
                    </label>
                  </div>
                  <div v-if="user.role.type == 3 || user.role.type == 1">
                    <input
                      type="radio"
                      value="individual"
                      v-model="model.role"
                      @input="model.type = 3"
                    />
                    <label>
                      Individual
                    </label>
                  </div>
                </div>
              </div>
  
              <div class="col-6">
                <Tree id="my-tree-id" ref="my-tree-ref" v-model="model.modules" :custom-options="myCustomOptions" :custom-styles="myCustomStyles" :nodes="data"></Tree>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>

  </form>
</template>

<script>
  import TextField from '@components/form2/textfield.vue'
  import { mapActions } from 'vuex'
  import FormMixin from '@mixins/form'

  export default {
    mixins: [FormMixin],
    components:{
      TextField
    },
    props: {
      parameters: null
    },
    data(){
      return {
        data: [],
        model:{
          name: '',
          role:'',
          type:Number
        },
        editedData: {},
        fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth
      }
    },
    async beforeMount(){
      await this.fetchData()
    },
    mounted(){
      window.addEventListener('resize', this.handleResize)
    },
    updated(){
      this.handleResize()
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize)
    },
    methods: {
      ...mapActions('role', ['get_modules']),
      async fetchData(){
        await this.get_modules().then(data => {
          this.data = data.data.modules
        })
      },
      handleResize () {
        let header = document.getElementById('sticky-header');
        this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

        if(header){
          header.style.width = this.fullWidth + 'px'
        }
      }
    },
    computed: {
      myCustomStyles() {
        return {
          row: {
            style: {
              width: '500px',
              cursor: 'pointer'
            },
            child: {
              class: '',
              style: {
                height: '35px'
              },
              active: {
                class: 'custom_row_active_class',
                style: {
                  height: '35px'
                }
              }
            }
          },
          addNode: {
            class: 'custom_class',
            style: {
              color: '#007AD5'
            }
          },
          editNode: {
            class: 'custom_class',
            style: {
              color: '#007AD5'
            }
          },
          deleteNode: {
            class: 'custom_class',
            style: {
              color: '#EE5F5B'
            }
          },
          selectIcon: {
            class: 'custom_class',
            style: {
              color: '#007AD5'
            },
            active: {
              class: 'custom_class',
              style: {
                color: '#2ECC71'
              }
            }
          },
          text: {
            style: {},
            class: 'capitalize',
            active: {
              style: {
                'font-weight': 'bold',
                color: '#2ECC71'
              }
            }
          }
        };
      },
      myCustomOptions() {
        return {
          treeEvents: {
            expanded: {
              state: true,
              fn: null,
            },
            collapsed: {
              state: false,
              fn: null,
            },
            selected: {
              state: false,
              fn: null,
            },
            checked: {
              state: true,
              fn: this.myCheckedFunction,
            }
          },
          events: {
            expanded: {
              state: true,
              fn: null,
            },
            selected: {
              state: false,
              fn: null,
            },
            checked: {
              state: false,
              fn: null,
            },
            editableName: {
              state: false,
              fn: null,
              calledEvent: null,
            }
          },
          addNode: { state: false, fn: null, appearOnHover: false },
          editNode: { state: true, fn: null, appearOnHover: true },
          deleteNode: { state: true, fn: null, appearOnHover: true },
          showTags: true,
        };
      }
    }
  }
</script>

